/* eslint-disable no-console */

export const UPDATE_QUERY = 'PNP/AUTOCOMPLETE/UPDATE_QUERY';
export const UPDATE_RESULTS = 'PNP/AUTOCOMPLETE/UPDATE_RESULTS';
export const SET_SELECTED = 'PNP/AUTOCOMPLETE/SET_SELECTED';
export const LOAD_REQUEST = 'PNP/AUTOCOMPLETE/LOAD_REQUEST';
export const LOAD_FAILED = 'PNP/AUTOCOMPLETE/LOAD_FAILED';
export const LOAD_SUCCESS = 'PNP/AUTOCOMPLETE/LOAD_SUCCESS';

export const initialState = {
    results: [],
    count: 0,
    query: ``,
    selectedIndex: -1,
    fetching: false,
    error: ``,
};

export const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case LOAD_FAILED:
            return {
                ...state,
                error: action.error,
                fetching: false,
            };
        case LOAD_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case UPDATE_RESULTS:
            return {
                ...state,
                results: action.results,
                count: action.count,
                query: action.query,
                selectedIndex: -1,
            };
        case SET_SELECTED:
            return {
                ...state,
                selectedIndex: action.selectedIndex,
            };
        default:
            return { ...state };
    }
};

export const autocompleteContext = (dispatch, service) => ({
    updateResults: (results, count) => {
        dispatch({
            type: UPDATE_RESULTS,
            results,
            count,
        });
    },
    setSelectedIndex: (selectedIndex) => {
        dispatch({
            type: SET_SELECTED,
            selectedIndex,
        });
    },
    fetchResults: async (query) => {
        if (!query) {
            dispatch({
                type: UPDATE_RESULTS,
                results: [],
                count: 0,
            });
            return;
        }
        dispatch({
            type: LOAD_REQUEST,
        });

        const { results, count, error } = await service.getResults(query);

        if (error) {
            console.error(
                `There was an error fetching results from the service.`
            );
            console.info(error.message);

            dispatch({
                type: UPDATE_RESULTS,
                results: [],
                count: 0,
            });

            dispatch({
                type: LOAD_FAILED,
                error: error.message,
            });
            return;
        }

        dispatch({
            type: UPDATE_RESULTS,
            results,
            count,
            query,
        });

        dispatch({
            type: LOAD_SUCCESS,
        });
    },
});
